import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "embedded row full-height full-width" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Search", -1)
const _hoisted_4 = { class: "col-5 full-height iodine-border" }

import { ref, watch } from 'vue';
  import CodesPane from 'components/codes/CodesPane.vue';
  import ReferencesEmbedded from 'components/references/ReferencesPaneCompact.vue';
  import ResourcesPane from 'components/resources/ResourcesPane.vue';
  import { useLayoutStore } from 'stores/layout-store';
  import { storeToRefs } from 'pinia';
  import { useGrouperStore } from 'stores/GrouperStore';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBodyEmbedded',
  setup(__props) {

  const tab = ref('research');
  const resourcesToggle = ref(false);
  watch(resourcesToggle, (newValue) => {
    useLayoutStore().setResourcesState(newValue);
  });

  const { getCodesCount } = storeToRefs(useGrouperStore());


return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_card, { class: "full-height" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "grouper-body-embedded-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tabs, {
                modelValue: tab.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                dense: "",
                "no-caps": "",
                class: "text-grey",
                "active-color": "primary",
                "indicator-color": "primary",
                align: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tab, {
                    name: "codes",
                    label: `Codes (${_unref(getCodesCount)})`
                  }, null, 8, ["label"]),
                  _createVNode(_component_q_tab, {
                    name: "search",
                    label: "Search"
                  }),
                  _createVNode(_component_q_tab, {
                    name: "references",
                    label: "References"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_q_space),
              _createVNode(_component_q_toggle, {
                modelValue: resourcesToggle.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((resourcesToggle).value = $event)),
                "checked-icon": "check",
                color: "$iodine-light-primary",
                "unchecked-icon": "clear",
                label: "Resources"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_tab_panels, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
            animated: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab_panel, {
                class: "codes-panel",
                name: "codes"
              }, {
                default: _withCtx(() => [
                  _createVNode(CodesPane)
                ]),
                _: 1
              }),
              _createVNode(_component_q_tab_panel, {
                class: "search-panel",
                name: "search"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(" Search Pane ")
                ]),
                _: 1
              }),
              _createVNode(_component_q_tab_panel, {
                class: "references-panel",
                name: "references"
              }, {
                default: _withCtx(() => [
                  _createVNode(ReferencesEmbedded)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(ResourcesPane)
    ], 512), [
      [_vShow, resourcesToggle.value]
    ])
  ]))
}
}

})